import React from 'react';
import { Typography } from 'antd';
import { faultHolder } from './issueFields';
import type {
	Program,
	ProgramIssue,
} from '../../interfaces/CamProgramming.interface';

const { Text } = Typography;

interface IssueListHeadMetaProps {
	issue: ProgramIssue;
	program?: Program;
}

/** Compact caught-in / at-fault labels for issue rows in list modals. */
const IssueListHeadMeta: React.FC<IssueListHeadMetaProps> = ({
	issue,
	program,
}) => {
	const holder = faultHolder(program, issue);
	const faultName = holder?.full_name || holder?.email || issue.fault_display;

	return (
		<>
			<Text type="secondary" className="cam-issue__by" ellipsis>
				Caught in {issue.caught_phase_display}
			</Text>
			<Text type="secondary" className="cam-issue__by" ellipsis>
				At fault: {faultName}
			</Text>
		</>
	);
};

export default IssueListHeadMeta;
